export class Links {
  constructor(route: string) {
    this.route = route;
  }
  route: string;
  label: string;
}
